export default __webpack_public_path__ + "static/media/impressions-line.389ae615.svg";